import { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { X, Download, Copy } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function QrModal({ open, onClose, url, title, color = "#A7E4C0" }) {
  const ref = useRef(null);
  if (!open) return null;

  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const dataUrl = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = `qr-${title.replace(/\s+/g, "-").toLowerCase()}.png`;
    a.click();
    toast.success("QR Code diunduh");
  };

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    toast.success("Tautan disalin");
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid="qr-modal">
      <div className="nb-card nb-card-lg p-6 max-w-sm w-full bg-white" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-start gap-3">
          <div>
            <span className="nb-badge" style={{ background: color }}>QR Code</span>
            <h2 className="font-display font-black text-2xl tracking-tight mt-2">{title}</h2>
          </div>
          <button onClick={onClose} className="nb-btn" data-testid="qr-close-button"><X size={18} weight="bold" /></button>
        </div>
        <div className="mt-5 flex flex-col items-center">
          <div ref={ref} className="p-4 bg-white border-2 border-[#121212] rounded-xl">
            <QRCodeCanvas
              value={url}
              size={240}
              level="H"
              includeMargin={false}
              fgColor="#121212"
              bgColor="#FFFFFF"
            />
          </div>
          <p className="mono text-xs text-[#4A4A4A] mt-3 break-all text-center">{url}</p>
        </div>
        <div className="flex gap-2 mt-5">
          <button onClick={download} className="nb-btn nb-btn-primary flex-1 justify-center" data-testid="qr-download-button">
            <Download size={18} weight="bold" /> Download PNG
          </button>
          <button onClick={copyLink} className="nb-btn" data-testid="qr-copy-link-button">
            <Copy size={18} weight="bold" />
          </button>
        </div>
        <p className="text-xs text-[#4A4A4A] mt-3 text-center">
          Cetak & tempel di meja, vitrin, atau bagikan di sosial media.
        </p>
      </div>
    </div>
  );
}
